/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", ["dashAnimation"], function () {
    // Локальные переменные
    var module = this;
    var activeThumb = document.querySelector("[data-slider-name='infoThumbs'] .js-active-thumb");
    if (activeThumb) {
        var viewport = itsoftApp.utils.getViewportSize();
        window.currentActiveStroke = activeThumb.querySelector(".thumb__stroke");
        window.sliderIsPaused = false;
    }

    var stopSlider = function (swiper) {
        swiper.autoplay.stop();
        swiper.keyboard.disable();
        itsoftApp.modules.dashAnimation.addDashLength(window.currentActiveStroke);
    }

    var startSlider = function (swiper, el) {
        swiper.autoplay.start();
        swiper.allowTouchMove = true;
        swiper.keyboard.enable();
        itsoftApp.modules.dashAnimation.startDashAnimation(window.currentActiveStroke, 6);
    }

    module.sliderSettingsObject = {
        global: {
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            slidesPerView: 3,
            centeredSlides: true,
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            speed: 500
        },

        galleryTop: {
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            speed: 500,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
            centeredSlides: true,
            // followFinger: false,
            watchOverflow: true,
            simulateTouch: false,
            followFinger: false,
            // preventInteractionOnTransition: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            initialSlide: 3,
            runCallbacksOnInit: false,
            on: {
                init: function () {
                    var swiper = this;
                    var slidersWrapper = this.el.closest(".js-double-slider");
                    var sliderInitiator = this.el.closest(".js-slider");
                    var sliderName = sliderInitiator.getAttribute("data-slider-name");
                    var thumbsName = sliderInitiator.getAttribute("data-thumbs");

                    this.slideTextElements = document.querySelectorAll(".js-slides-transition .js-scroll-transition");

                    Swiper.initedSliders[sliderName] = this;

                    if (slidersWrapper && thumbsName) {
                        var thumbsInitiator = slidersWrapper.querySelector("[data-slider-name='" + thumbsName + "']");
                        var thumbsKey = thumbsInitiator.getAttribute("data-slider-settings");
                    }

                    if (thumbsInitiator) {
                        itsoftApp.modules.slidersLibrary.callback(thumbsInitiator, itsoftApp.modules.slidersSettings.sliderSettingsObject[thumbsKey]);
                    }

                    var infoTextBlock = document.querySelector(".info__text-block");
                    var infoImageBlock = document.querySelector(".info__slider-top");

                    if (viewport >= 1280) {
                        if (infoTextBlock) {
                            infoTextBlock.addEventListener("mouseenter", function () {
                                stopSlider(swiper);
                            });

                            infoTextBlock.addEventListener("mouseleave", function () {
                                startSlider(swiper);
                            });
                        }

                        if (infoImageBlock) {
                            infoImageBlock.addEventListener("mouseenter", function () {
                                stopSlider(swiper);
                            });

                            infoImageBlock.addEventListener("mouseleave", function () {
                                startSlider(swiper);
                            });
                        }

                        window.addEventListener("blur", function () {
                            stopSlider(swiper);
                        });

                        window.addEventListener("focus", function () {
                            startSlider(swiper);
                        });
                    }
                },

                slideChange: function () {
                    var swiper = this;
                    window.sliderIsPaused = true;
                    swiper.allowTouchMove = false;
                    swiper.keyboard.disable();

                    setTimeout(function () {
                        window.sliderIsPaused = false;
                        swiper.allowTouchMove = true;
                        swiper.keyboard.enable();
                    }, 500);

                    var slideActiveText = document.querySelector(".js-slides-transition .js-scroll-transition.js-visible");

                    if (!slideActiveText) {
                        slideActiveText = document.querySelector(".js-slides-transition .js-scroll-transition.js-invisible")
                        slideActiveText.classList.remove("js-invisible");
                    }

                    var activeThumb = document.querySelector("[data-slider-name='infoThumbs'] .js-active-thumb");
                    var activeThumbStroke = activeThumb.querySelector(".thumb__stroke");
                    activeThumb.classList.remove("js-active-thumb");
                    var currentActiveIndex = this.activeIndex;
                    var currentActiveThumb = Swiper.initedSliders["infoThumbs"].slides[currentActiveIndex];
                    window.currentActiveStroke = currentActiveThumb.querySelector(".thumb__stroke");

                    // swiper.autoplay.stop();
                    // swiper.allowTouchMove = false;
                    itsoftApp.modules.dashAnimation.addDashLength(activeThumbStroke);

                    slideActiveText.classList.remove("js-visible");
                    slideActiveText.classList.add("js-process-hidden");
                    this.slideTextElements[currentActiveIndex].classList.add("js-process-visible");

                    // setTimeout(function () {
                    requestAnimationFrame(function () {
                        requestAnimationFrame(function () {
                            slideActiveText.classList.remove("js-process-hidden");
                            swiper.slideTextElements[swiper.activeIndex].classList.remove("js-process-visible");
                            swiper.slideTextElements[swiper.activeIndex].classList.add("js-visible");
                            // activeThumb.classList.remove("js-active-thumb");
                            currentActiveThumb.classList.add("js-active-thumb");
                            // swiper.autoplay.start();
                            itsoftApp.modules.dashAnimation.startDashAnimation(window.currentActiveStroke, 6);
                            // swiper.allowTouchMove = true;
                        })
                    });
                    // }, 300);
                }
            }
        },

        galleryThumbs: {
            spaceBetween: 1,
            slidesPerView: 5,
            watchOverflow: true,
            simulateTouch: false,
            followFinger: false,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            breakpoints: {
                1024: {
                    spaceBetween: 20
                }
            },
            on: {
                init: function () {
                    var swiper = this;
                    var slidersWrapper = this.el.closest(".js-double-slider");
                    var sliderInitiator = this.el.closest(".js-slider");
                    var sliderName = sliderInitiator.getAttribute("data-slider-name");
                    var parentName = sliderInitiator.getAttribute("data-parent-slider");
                    var thumbStrokeEls = sliderInitiator.querySelectorAll(".thumb__stroke");

                    if (thumbStrokeEls.length > 0) {
                        Array.prototype.forEach.call(thumbStrokeEls, function (thumbStroke, index) {
                            if (viewport >= 1280 && thumbStroke.hasAttribute("vector-effect")) {
                                thumbStroke.removeAttribute("vector-effect");
                            }

                            itsoftApp.modules.dashAnimation.addDashLength(thumbStroke);
                        });
                    }

                    itsoftApp.modules.windowResize.addEvent(function () {
                        if (thumbStrokeEls.length > 0) {
                            Array.prototype.forEach.call(thumbStrokeEls, function (thumbStroke) {
                                itsoftApp.modules.dashAnimation.addDashLength(thumbStroke);
                            });
                        } 
                    });

                    var activeThumb = document.querySelector("[data-slider-name='infoThumbs'] .js-active-thumb");
                    var activeThumbStroke = activeThumb.querySelector(".thumb__stroke");

                    itsoftApp.modules.dashAnimation.startDashAnimation(activeThumbStroke, 6);

                    Swiper.initedSliders[sliderName] = this;

                    // Swiper.initedSliders[parentName].controller.control = this;
                    // this.controller.control = Swiper.initedSliders[parentName];

                    Array.prototype.forEach.call(swiper.slides, function (slide, slideIndex) {
                        slide.addEventListener("click", function () {
                            if (!window.sliderIsPaused) {
                                Swiper.initedSliders[parentName].slideTo(slideIndex);
                            }
                        })
                    });
                }
            }
        }
    };
});